import styled from '@emotion/styled/macro'

import { pageContentDefaultSize } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const BillingContainer = styled('div')`
  ${pageContentDefaultSize}

  h2 {
    color: var(--CINight);
    margin: 38px 0 72px;

    ${mediaQuery('tablet')} {
      margin: 24px 0 48px;
    }
  }

  p {
    color: var(--slate-60);
    text-align: center;
  }
`

export { BillingContainer }
